import { Anchor, AnchorExtendedProps, Button } from 'grommet';
import React from 'react';
import { LinkProps, useNavigate } from 'react-router-dom';

export const AnchorLink: React.FC<AnchorLinkProps> = (props) => {
  const navigate = useNavigate();
  return <Anchor as={Button} {...props} onClick={() => navigate(props.to)} />;
};

export type AnchorLinkProps = LinkProps & AnchorExtendedProps;
